import { useQuery } from '@tanstack/react-query';
import { fetchMyUserTests } from '../api/userTestsApi';

export const MY_USER_TESTS_KEY = 'my-user-tests';

export const useMyUserTests = () => {
  return useQuery({
    queryKey: [MY_USER_TESTS_KEY],
    queryFn: fetchMyUserTests,
    staleTime: 30_000,
  });
};
